import React from 'react'
import { Row, Col, Table, Tag, Space, Image } from 'antd';
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import _ from 'lodash'
import API from '@/api'
import './index.less'

const { Column } = Table;

const failImg = 'data:image/png;base64,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'

@withRouter
@connect(
  state => ({
    categories: state.categories
  })
  , null, null, { forwardRef: true })
class ArticleList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      tableData: []
    }
  }

  getArticle = async function (params) {
    const res = await API.GetArticles(params)
    if (res.code !== 200) return []
    return res.result
  }

  fetchData = (params = {}) => {
    const { selectedCategories } = this.props
    if (selectedCategories && selectedCategories.length) {
      params.fetch_category_id = selectedCategories[0]
    } else {
      delete params.fetch_category_id
    }

    return new Promise((resolve, reject) => {
      this.getArticle(params).then(result => {
        resolve(result.rows)
      })
      // setTimeout(() => {
      //   resolve([ ...this.state.tableData ])
      // }, 2000)
    })
  };

  editArticle = id => {
    this.props.history.push({
      pathname: `/admin/edit/${id}`
    })
  }

  viewArticle = id => {
    this.props.history.push({
      pathname: `/article/${id}`
    })
  }

  init = async () => {
    const tableData = await this.fetchData()
    console.log('tableData', tableData)
    this.setState({ tableData })
  }

  async componentDidMount () {
    this.init()
  }

  render () {
    const { editArticle, viewArticle } = this
    const { tableData } = this.state
    const { categories } = this.props

    return (
      <div>
        <Row gutter={18}>
          <Col span={24}>
            <Row gutter={18}>
              <Col span={24}>
                <Table dataSource={tableData} rowKey="id" size="small">
                  <Column title="主图" dataIndex="main_image_url" key="main_image_url" render={url => (
                    <Image src={url || 'error'} fallback={failImg} width={60} height={60} />
                  )} />
                  <Column title="标题" dataIndex="title" key="title" render={(title, item) => (
                    <a onClick={() => viewArticle(item.id)}>{title}</a>
                  )} />
                  <Column title="简述" dataIndex="intro" key="intro" render={text => {
                    return <div style={{ color: text ? '#555' : '#ccc' }}>{text || '暂无简述'}</div>
                  }} />
                  <Column title="是否开放" dataIndex="open_flag" key="open_flag" render={flag => (
                    flag ? <Tag color="green">已开放</Tag> : <Tag>未开放</Tag>
                  )} />
                  <Column title="所属分类" dataIndex="categories" key="categories" render={cats => (
                    <>
                      {cats && cats.map(id => {
                        const category = _.find(categories, { id }) || {}
                        return (
                          <Tag color="gold" key={id}>
                            {category.title}
                          </Tag>
                        );
                      })}
                    </>
                  )} />
                  <Column title="操作" dataIndex="id" key="id" render={id => (
                    <Space size="middle">
                      <a onClick={() => editArticle(id)}>查看</a>
                    </Space>
                  )}>
                  </Column>
                </Table>
              </Col>
            </Row>
            <Row gutter={18}>
              <Col span={24}>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ArticleList
